<template>
  <transition :css="false" @appear="enter">
    <div id="app" class="AgeGate">
      <form
        ref="form"
        id="form-date"
        class="AgeGate-form"
        method="post"
        action="/agegate/setage"
      >
        <input type="hidden" v-model="redirect" name="redirect" />
        <img
          class="AgeGate-logo"
          ref="logo"
          src="@/assets/img/logo.svg"
          alt="Carta Blanca"
        />
        <h2 class="AgeGate-title" ref="title">
          Ingresa tu fecha de nacimiento
        </h2>
        <div class="AgeGate-date" ref="date">
          <DateInput
            day
            v-model="day"
            placeholder="DD"
            @keypress.native="clearError"
            @filled="() => focusNext('month')"
            autofocus
          />
          <span>/</span>
          <DateInput
            month
            ref="month"
            v-model="month"
            placeholder="MM"
            @keypress.native="clearError"
            @filled="() => focusNext('year')"
          />
          <span>/</span>
          <DateInput
            year
            ref="year"
            v-model="year"
            placeholder="YY"
            @keypress.native="clearError"
            @filled="login"
          />
        </div>
        <div class="AgeGate-error">{{ error }}</div>
        <div class="AgeGate-btn" ref="loginBtn" @click="() => login()">
          Entrar
        </div>
        <div class="AgeGate-btn AgeGate-btn--fb" ref="fbBtn" @click="fbLogin">
          Iniciar sesion con Facebook
        </div>
      </form>

      <Cookiess :visible="cookiessVisible" @close="cookiessVisible = false" />
      <Terms :visible="termsVisible" @close="termsVisible = false" />
      <Aviso :visible="avisosVisible" @close="avisosVisible = false" />

      <Cookiess :visible="cookiesVisible" @close="cookiesVisible = false" />
      <Terms :visible="termVisible" @close="termVisible = false" />
      <Aviso :visible="avisoVisible" @close="avisoVisible = false" />

      <div class="content">
        <div class="cookiess-link" ref="link" @click="cookiessVisible = true">
          Política de cookies
        </div>
        <div class="cookiess-link" ref="link"  @click="avisosVisible = true">
          Aviso de Privacidad
        </div>
        <div class="cookiess-link" ref="link" @click="termsVisible = true">
           Términos y condiciones
        </div>
        <!-- <div class="avisos-link" ref="link" @click="avisosVisible = true">
          Aviso de Privacidad
        </div>
        <div class="terms-link" ref="link" @click="termsVisible = true">
          Términos y condiciones
        </div> -->
      </div>

      <div class="bannerCookies" id="allowCookies">
        <p>
          Este sitio web utiliza cookies. Para obtener más información, puedes
          consultar nuestra Política de Cookies. Al continuar navegando aceptas
          la <a @click="cookiesVisible = true"> POLÍTICA DE COOKIES</a>, la
          <a @click="avisoVisible = true">POLÍTICA DE PRIVACIDAD</a> y los
          <a @click="termVisible = true">TÉRMINOS Y CONDICIONES</a> de este
          sitio web.
        </p>
        <button class="btn-cookies" id="allowCook" @click="Cookies()">
          CERRAR
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import DateInput from "@/components/DateInput";
import gsap from "gsap";
import moment from "moment";
import Aviso from "@/components/Aviso";
import Terms from "@/components/Terms";
import Cookiess from "@/components/Cookies";
import Xeerpa from "@/foo/net/api/XeerpaApi";
import TagFunctions from "../../../../front/src/assets/tagFunctions.js";
import Cookies from "js-cookie";

moment.parseTwoDigitYear = function (yearString) {
  const parsedYear = parseInt(yearString);
  const diffYear = moment().year() - 2000;
  const baseYear = parsedYear > diffYear ? 1900 : 2000;
  return baseYear + parsedYear;
};

const fbLogin = async callback => {
  try {
    const xeerpa = await Xeerpa.loginAsync();
    const birthday = moment(xeerpa.user.birthday);
    const xeerpaJson = JSON.stringify(xeerpa);
    const cookie = `xeerpaResponse=${xeerpaJson}; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
    document.cookie = cookie;
    if (typeof callback === "function") callback({ birthday });
  } catch (error) {
    if (typeof callback === "function") callback({ error });
  }
};

export default {
  name: "AgeGate",
  components: {
    DateInput,
    Aviso,
    Terms,
    Cookiess,
  },
  data: () => ({
    day: undefined,
    month: undefined,
    year: undefined,
    error: undefined,
    redirect: undefined,
    avisoVisible: false,
    termVisible: false,
    cookiesVisible: false,
    avisosVisible: false,
    termsVisible: false,
    cookiessVisible: false,
  }),
  mounted() {
    this.Cookies();
  },
  computed: {
    birthday() {
      const { month, day, year } = this;
      const date = moment(`${month} ${day} ${year}`, "MM DD YY");
      return date;
    },
  },

  created() {
    let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
    this.redirect = params.get("redirect");
  },

  methods: {
    Cookies() {
      const botonCerrarCookies = document.getElementById("allowCook");
      const avisoCookies = document.getElementById("allowCookies");

      if (!localStorage.getItem("cookies-aceptadas")) {
        avisoCookies.classList.add("activo");
      }
      botonCerrarCookies.addEventListener("click", () => {
        console.log("me diste click");
        avisoCookies.classList.remove("activo");
        localStorage.setItem("cookies-aceptadas", true);
      });
    },
    focusNext(refKey) {
      const { $refs } = this;
      $refs[refKey].$el.focus();
    },
    enter(el, done) {
      const { $refs } = this;
      const elems = [
        $refs.logo,
        $refs.title,
        $refs.date,
        $refs.loginBtn,
        $refs.fbBtn,
        $refs.link,
      ];

      gsap.fromTo(
        elems,
        { alpha: 0, y: "20px" },
        {
          alpha: 1,
          y: "0",
          delay: 0.2,
          stagger: 0.1,
          onComplete: done,
          duration: 0.75,
          ease: "power3.out",
        },
      );
    },
    isAdult(birthday) {
      const today = moment();
      const age = today.diff(birthday, "years");
      return age >= 18;
    },
    submit(birthday, network) {
      //window.digitalData.user.profile.profileInfo.ageUserCountry = this.geoFindMe();

      if (this.validBirthday(birthday)) {
        Cookies.set("ageUserBirthYear", birthday.format("YYYY"));
        Cookies.set("ageUser", moment().diff(birthday, "years"));
        if (network == "Facebook") {
          Cookies.set("network", "Facebook");
          if (Xeerpa.userData.user.email) {
            Cookies.set("email", Xeerpa.sha256(Xeerpa.userData.user.email));
            Cookies.set("userId", Xeerpa.userData.id);
          } else {
            Cookies.set("email", "NA");
            Cookies.set("userId", "NA");
          }
        } else {
          Cookies.set("network", "Normal");
          Cookies.set("email", "NA");
          Cookies.set("userId", "NA");
        }

        TagFunctions.evAgeGatePush("Exito");
        setTimeout(() => {
          this.$refs.form.submit();
        }, 1500);
      }
    },
    /*
    geoFindMe() {
      if (!navigator.geolocation){
        console.log("Geolocation is not supported by your browser");
        return;
      }
      function success(position) {
        var latitude  = position.coords.latitude;
        var longitude = position.coords.longitude;
        window.reverseGeocodingWithGoogle(longitude, latitude)
      }
      function error() {
        console.log("Unable to retrieve your location");
      }
      navigator.geolocation.getCurrentPosition(success, error);
      return navigator.geolocation.getCurrentPosition(success, error);
    },
    */
    login() {
      TagFunctions.evAgeGatePush("Intento");
      const { birthday } = this;
      if (this.validFields()) {
        this.submit(birthday, "Normal");
      }
    },
    fbLogin() {
      TagFunctions.evAgeGatePush("Intento");
      this.error = undefined;
      fbLogin(({ birthday, error }) => {
        if (error) {
          TagFunctions.evAgeGatePush("Error", error);
          this.error = error;
        } else {
          this.submit(birthday, "Facebook");
        }
      });
    },
    validBirthday(birthday) {
      this.error = undefined;
      if (birthday.isValid()) {
        const today = moment();
        const age = today.diff(birthday, "years");
        if (age < 18) {
          this.error = "Debe ser mayor de edad";
          TagFunctions.evAgeGatePush("Error", this.error);
        }
      } else {
        this.error = "Fecha inválida";
        TagFunctions.evAgeGatePush("Error", this.error);
      }
      return this.error === undefined;
    },
    validFields() {
      const { day, month } = this;
      this.error = undefined;
      if (!this.validField(day, 1, 31)) {
        this.error = "Día incorrecto, el valor debe ser entre 01 y 31";
        TagFunctions.evAgeGatePush("Error", this.error);
      } else if (!this.validField(month, 1, 12)) {
        this.error = "Mes incorrecto, el valor debe ser entre 01 y 12";
        TagFunctions.evAgeGatePush("Error", this.error);
      }
      return this.error === undefined;
    },
    validField(value, min, max) {
      const parsedValue = parseInt(value);
      return !isNaN(parsedValue) && parsedValue >= min && parsedValue <= max;
    },
    clearError() {
      if (this.error !== undefined) {
        this.error = undefined;
      }
    },
  },
};
</script>

<style lang="stylus">
@import './AgeGate.styl';

.cookiess-link {
 
  bottom: 0;
  left: calc(50% - 100px);
  top: calc(100% - 80px);
  text-align: center;
  text-decoration: underline;
  padding: 10px 0;
  clickable();
  margin: -1vw 1vw 0vw 1vw;
}

.content{
  text-align: center;
  height: 0%;
}

.bannerCookies {
  display: none;
  color: aliceblue;
  background: rgba(5, 5, 5, 0.8);
  /* margin-left: 2%; */
  position: fixed;
  bottom: -80px;
  z-index: 100;
  /* justify-content: space-between; */
  width: 103%;
  margin: -1.5%;
  height: 15%;
  padding: 0vw 0vw 16vw 1vw;
}

.bannerCookies.activo {
  display: flex;
  align-items: start;
  justify-content: space-around;
  flex-direction: row;
}

.bannerCookies p {
  margin: 3% 5%;
  color: aliceblue;
  width: 75%;
  margin-left: -3%;
  font-size: 1.3vw;
}

.bannerCookies a {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}

.btn-cookies {
  color: #fff;
  border: 0.3vw solid white;
  padding: 0.5em 0.7em;
  background: transparent;
  border-width: medium;
  margin: 3.5vw 1.5vw 1vw -20vw;
}

.bannerCookies p a {
  color: #00beff;
}

@media only screen and (max-width: 768px) {
  .bannerCookies {
    display: none;
    color: aliceblue;
    background: rgba(5, 5, 5, 0.8);
    padding: 1vw 3vw 37vw 1vw;
    /* margin-left: 2%; */
    position: fixed;
    min-width: 100%;
    bottom: 3.5px;
    height: 19.8%;
  }

  .bannerCookies.activo {
    display: flex;
    align-items: start;
    justify-content: space-around;
    flex-direction: row;
  }

  .btn-cookies {
    margin: 13.1vw 0 0 -6vw;
    font-size: 2vw !important;
    padding: 1vw 3vw 3vw 3vw;
    height: 9%;
    display: flex;
    border: 0.2vw solid;
    margin-right: 2%;
  }

  .bannerCookies p {
    font-size: 3.45vw;
    padding: 1.5vw 0.5vw 0.5vw 4.5vw;
    margin-left: -1%;
  }

  .bannerCookies table {
    max-width: 20%;
    font-family: Wood-Bonnet-Grotesque !important;
    font-size: 1.7vw !important;
  }

  .bannerCookies th {
    font-size: 2vw;
  }

  .bannnerCookies td {
    font-size: 2vw;
    padding-left: 6px;
  }
}

</style>
